<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PricingPrices from "../../../components/pricingPrices";
import PricingPackages from "../../../components/pricingPackages";
import NoPricingCard from '../../../components/noPricingCard';
import {mapState} from "vuex";

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "My pricing",
    meta: [{ name: "description", content: appConfig.description }],
  },
  data () {
    return {
      onDemand: false
    };
  },
  components: {
    PricingPrices,
    PricingPackages,
    Layout,
    NoPricingCard
  },
  computed: {
    ...mapState('user', {
      pricing_on_demand: (state) => state.user.pricing_on_demand,
    }),
    noPricing () {
      if(this.pricing_on_demand === undefined) {
        return true;
      } else {
        return this.pricing_on_demand;
      }
    },
    initialTab () {
      return this.$route.query.tab;
    }
  },
};
</script>

<template>
  <Layout>
<!--    TODO: no pricing card and switch-->
    <div v-if="noPricing" class="row">
      <div class="col">
        <NoPricingCard />
      </div>
    </div>
    <div v-else class="row">
      <div class="col">
        <div class="card">
          <div class="card-body">
            <b-tabs nav-class="nav-tabs-custom" content-class="text-muted">
              <b-tab :active="!initialTab">
                <template v-slot:title>
                  Prices
                </template>

                <PricingPrices />

              </b-tab>
              <b-tab :active="initialTab === 'pricepackages'">
                <template v-slot:title>
                  Packages
                </template>

                <PricingPackages />

              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
